/**
 * Created by Phatbass on 26/02/16.
 */

var url_regexp = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;

angular.module('dekky.forms.validators.urlOnly', [])
    .directive('urlOnly', function() {
    return {
        require: '?ngModel',
        link: function(scope, element, attr, ngModelController) {
            ngModelController.$parsers.unshift(function (value) {
                if (url_regexp.test(value)) {
                    ngModelController.$setValidity('urlOnly', true);
                    return value;
                } else {
                    ngModelController.$setValidity('urlOnly', false);

                    return undefined;
                }
            });
        }
    };
});